import FooterLink from "@common/table/footer/footerLink"
import { FooterLinkProps, RTable } from "@common/table/types"

type TableFooterProps = { table: RTable } & FooterLinkProps

const TableFooter = ({ table, ...rest }: TableFooterProps) => {
  const colSpan = table.getVisibleLeafColumns()?.length
  return (
    <tfoot>
      <tr className="table-row">
        <td colSpan={colSpan} className="table-cell text-center">
          <FooterLink {...rest} />
        </td>
      </tr>
    </tfoot>
  )
}

export default TableFooter
